export default __webpack_public_path__ + "assets/img_calculator_holidayhome_expensive-fb61bf59.jpg";